/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Play Fill',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M12 0C5.38335 0 0 5.38308 0 12C0 18.6169 5.38308 24 12 24C18.6169 24 24 18.6169 24 12C24 5.38308 18.6172 0 12 0ZM17.5142 12.5211L9.48497 18.3022C9.37352 18.3825 9.24189 18.4232 9.10955 18.4232C9.00939 18.4232 8.90913 18.3998 8.81661 18.3526C8.60208 18.2428 8.46721 18.0218 8.46721 17.7809V6.21877C8.46721 5.97789 8.60207 5.75687 8.81661 5.64711C9.03083 5.53754 9.28905 5.55626 9.48467 5.6975L17.5139 11.4786C17.6816 11.5993 17.7812 11.7934 17.7812 11.9999C17.7812 12.2063 17.6816 12.4004 17.5142 12.5211L17.5142 12.5211Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
